import React from 'react';
import { message } from 'antd';
import { isEmpty } from 'lodash';
import { inject, observer } from 'mobx-react';
import { getProjectDetail, getProjectReports } from '@gtintel/platform-api';
import { LoadingSpinner2 } from '@gtintel/platform-atoms';
import { BatchType } from '@gtintel/platform-types';
import ReportsTab from './ReportsTab';
class ProjectDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.updateSearchPartnerInput = void 0;
    this.state = {
      loading: true,
      modalPreviewPDF: false,
      projectReports: null,
      projects: null,
      typeBatch: null
    };
  }
  static async getInitialProps({
    query
  }) {
    return {
      query
    };
  }
  componentDidMount() {
    this.fetchProjectData();
  }
  componentDidUpdate(prevProps) {
    if (this.props.query.id !== prevProps.query.id) {
      this.setState({
        loading: true
      }, () => {
        this.fetchProjectData();
      });
    }
  }
  async fetchProjectData() {
    const {
      adminProjectDetailStore
    } = this.props;
    try {
      // Make sure we don't hide the loading spinner false until all these
      // calls are finished, or the UI looks janky
      await Promise.all([getProjectDetail(this.props.query.id).then(res => {
        const projects = {
          ...res,
          statusDetail: res.status,
          typeBatch: res.source
        };
        this.setState({
          projects
        });
      }).catch(() => message.error('Could not load project.')), adminProjectDetailStore.fetchProjectDetail(Number(this.props.query.id)).then(() => {
        const {
          projectDetail
        } = adminProjectDetailStore;
        if (projectDetail) {
          adminProjectDetailStore.setBatchType(projectDetail.source || BatchType.STANDARD);
          adminProjectDetailStore.fetchProjectReports(projectDetail.id);
        }
      })]);
      adminProjectDetailStore.fetchProjectType();
      adminProjectDetailStore.fetchCategoryTag();
      getProjectReports(Number(this.props.query.id)).then(projectReports => this.setState({
        projectReports: {
          ...projectReports
        }
      }));
    } catch {
      message.error('An unknown error occurred.');
    } finally {
      this.setState({
        loading: false
      });
    }
  }
  render() {
    const {
      projects
    } = this.state;
    return <>
        {this.state.loading || isEmpty(projects) ? <LoadingSpinner2 margin="150px" /> : <ReportsTab projectId={Number(this.props.query.id)} />}
      </>;
  }
}
export default inject('adminProjectDetailStore')(inject('partnerStore')(observer(ProjectDetailPage)));